import { render, staticRenderFns } from "./XTextarea.vue?vue&type=template&id=ade70afe&scoped=true&"
import script from "./XTextarea.vue?vue&type=script&lang=js&"
export * from "./XTextarea.vue?vue&type=script&lang=js&"
import style0 from "./XTextarea.vue?vue&type=style&index=0&id=ade70afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade70afe",
  null
  
)

export default component.exports